import api from './api';
import { formatDateTimeAr } from '../utils/formatters';

export interface ApiVersionInfo {
  version: string;
  buildNumber?: number | null;
  lastUpdated?: string | null;
  commit?: string | null;
}

export async function getApiVersion(): Promise<ApiVersionInfo> {
  const response = await api.get<ApiVersionInfo>('/api/Version');
  return response.data;
}

export function formatApiVersionTooltip(info: ApiVersionInfo | null): string {
  if (!info?.version) return 'API: no disponible';

  const parts: string[] = [];
  if (info.buildNumber != null) {
    parts.push(`API v${info.version} Build ${info.buildNumber}`);
  } else {
    parts.push(`API v${info.version}`);
  }

  if (info.lastUpdated) {
    const updatedAt = formatDateTimeAr(info.lastUpdated);
    if (updatedAt) {
      parts.push(`Actualizado: ${updatedAt}`);
    }
  }

  return parts.join(' · ');
}
